import { Maybe } from 'ballerina-core'

export type SearchBarState = { show: boolean; searchQuery: string }

export const initialSearchBarState = (searchQuery: Maybe<string>): SearchBarState => ({
  show: false,
  searchQuery: searchQuery || '',
})


